import Grid from '@mui/material/Grid'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import globalStore from 'store/global/global'
import { Tabs } from 'ui/atoms'
import { useAuth } from 'ui/components/AuthContext/AuthContext'
import ModuleHeader from 'ui/components/ModuleHeader/ModuleHeader'
import View from 'ui/components/View/View'
import { useSnapshot } from 'valtio'
import AncillaryServices from './components/AncillaryServices/AncillaryServices'
import DayAheadBidManagement from './components/DayAheadBidManagement/DayAheadBidManagement'
import DayAheadOverview from './components/DayAheadOverview/DayAheadOverview'
import DayAheadPlan from './components/DayAheadPlan/DayAheadPlan'
import { DayAheadPriceScenarios } from './components/DayAheadPriceScenarios/DayAheadPriceScenarios'
import styles from './ElectricityTradingView.module.less'

enum TAB_ID {
  DAY_AHEAD_PRICE_SCENARIOS = 'day_ahead_price_scenarios',
  DAY_AHEAD_BID_MANAGEMENT = 'day_ahead_bid_management',
  DAY_AHEAD_OVERVIEW = 'day_ahead_overview',
  DAY_AHEAD_PLAN = 'day_ahead_plan',
  ANCILLARY_SERVICES = 'ancillary_services',
}

export function ElectricityTradingView() {
  const { t } = useTranslation()
  const { hasAccess } = useAuth()
  const [tabId, setTabId] = useState<string>('')
  const width = useSnapshot(globalStore).cardWidth

  const submoduleToTabItemMap = {
    [TAB_ID.DAY_AHEAD_PRICE_SCENARIOS]: {
      id: TAB_ID.DAY_AHEAD_PRICE_SCENARIOS,
      title: t('Day ahead price scenarios'),
      children: [],
    },
    [TAB_ID.DAY_AHEAD_BID_MANAGEMENT]: {
      id: TAB_ID.DAY_AHEAD_BID_MANAGEMENT,
      title: t('Day ahead bid management'),
      children: [],
    },
    [TAB_ID.DAY_AHEAD_OVERVIEW]: {
      id: TAB_ID.DAY_AHEAD_OVERVIEW,
      title: t('Day ahead overview'),
      children: [],
    },
    [TAB_ID.DAY_AHEAD_PLAN]: {
      id: TAB_ID.DAY_AHEAD_PLAN,
      title: t('Day ahead plan'),
      children: [],
    },
    [TAB_ID.ANCILLARY_SERVICES]: {
      id: TAB_ID.ANCILLARY_SERVICES,
      title: t('Ancillary services'),
      children: [],
    },
  }

  const tabs = Object.entries(submoduleToTabItemMap)
    .filter(([key]) => hasAccess({ module: 'electricitytrading', submodule: `electricitytrading_${key}` }))
    .map(([, value]) => value)

  return (
    <div className={styles.ElectricityTradingView}>
      <View
        header={
          <>
            <ModuleHeader infoHeader={t(`Electricity Trading`)} />
            <div className={styles.ElectricityTradingView_Tabs}>
              <Tabs
                items={tabs}
                onChange={(_, id) => {
                  setTabId(id as string)
                }}
                innerLeftPadding
                marginBottom={false}
                uniqueStorageKey={`ElectricityTradingTabs`}
              />
            </div>
          </>
        }
      >
        {tabId === TAB_ID.DAY_AHEAD_PRICE_SCENARIOS && (
          <Grid size={{ xs: 12 }} width={width}>
            <DayAheadPriceScenarios />
          </Grid>
        )}
        {tabId === TAB_ID.DAY_AHEAD_BID_MANAGEMENT && (
          <Grid size={{ xs: 12 }} width={width}>
            <DayAheadBidManagement />
          </Grid>
        )}
        {tabId === TAB_ID.DAY_AHEAD_OVERVIEW && (
          <Grid size={{ xs: 12 }} width={width}>
            <DayAheadOverview />
          </Grid>
        )}
        {tabId === TAB_ID.DAY_AHEAD_PLAN && (
          <Grid size={{ xs: 12 }} width={width}>
            <DayAheadPlan />
          </Grid>
        )}
        {tabId === TAB_ID.ANCILLARY_SERVICES && (
          <Grid size={{ xs: 12 }} width={width}>
            <AncillaryServices />
          </Grid>
        )}
      </View>
    </div>
  )
}
